// extracted by mini-css-extract-plugin
export default {"container":"style_container__dypRd","btn":"style_btn__Ebnmx","openedContainer":"style_openedContainer__Vnk8b"};